module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0001.jpg?v=f81d27af";